import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { Field } from '@grandvisionhq/forms';
import ControlledCheckbox from './ControlledCheckbox/ControlledCheckbox.js';

var _id;
const CheckboxField = (_param)=> {
    var { label , 'data-t': dataT , 'aria-label': ariaLabel  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "label",
        'data-t',
        'aria-label'
    ]);
    return React.createElement(Field, swcHelpers.extends({}, rest), /*#__PURE__*/ React.createElement(ControlledCheckbox, {
        id: (_id = rest.id) !== null && _id !== void 0 ? _id : rest.name,
        name: rest.name,
        "data-t": dataT,
        "aria-label": ariaLabel,
        label: label
    }));
};

export { CheckboxField as default };
//# sourceMappingURL=CheckboxField.js.map
